import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/warehouses.js';
import form from '../forms/warehouses.js';
import * as types from '../types.js';

const warehouses = function()
{

	let warehouses_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			let q = query || '';
			if (!/[?&]include_disabled=/.test(q))
				q += (q.includes('?') ? '&' : '?') + 'include_disabled=1';
			return await api.call(api.list_warehouses, q);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_warehouse, ...JSON.parse(id));
			if (_record && typeof _record === 'object')
			{
				_record.is_disabled =
					_record.is_disabled === true || _record.is_disabled === '1' ? '1' : '0';
			}
			return _record;
		},
		async saveRecord(data, old_data)
		{
			if (old_data)
			{
				return await api.call(api.patch_warehouse, data.company_id, data.id, {
					name: data.name,
					is_disabled: data.is_disabled == '1' || data.is_disabled === true,
				});
			}
			return await api.call(api.insert_warehouse, data.company_id, { name: data.name });
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Armazém', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do armazém' },
		{ index: 3, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome do armazém' },
		{ index: 4, field: 'is_disabled', label: 'Inativo', types: [], placeholder: '', title: 'Armazém inativo (não aparece em listagens operacionais)' },
	];

	warehouses_crud.run(
		'warehouses',
		'Armazéns',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs
	);

};

export default warehouses;

